<div class="page-title-box">
  <h4 class="page-title mb-1">
    {{ "campaign.templates.pageTitle" | translate }}
  </h4>
</div>

<!-- Abas do módulo -->
<ul class="nav nav-tabs nav-bordered mb-2" role="tablist">
  <li class="nav-item" role="presentation">
    <a
      class="nav-link"
      role="tab"
      [attr.aria-selected]="false"
      [routerLink]="['/campaign']"
    >
      {{ "campaign.campaignList.tabCampaigns" | translate }}
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a
      class="nav-link active"
      href="javascript:void(0);"
      role="tab"
      [attr.aria-selected]="true"
    >
      {{ "campaign.campaignList.tabTemplates" | translate }}
    </a>
  </li>
</ul>

<div class="card mb-2">
  <div class="card-body">
    <div class="row g-2 align-items-center">
      <div class="col-12 col-md-auto">
        <label class="form-label mb-0" for="campaign-template-channel">
          {{ "campaign.templates.chooseChannel" | translate }}
        </label>
      </div>
      <div class="col-12 col-md-5 col-lg-4">
        <select
          id="campaign-template-channel"
          class="form-select"
          [ngModel]="selectedChannel?._id ?? ''"
          (ngModelChange)="selectChannel($event)"
          [disabled]="loadingContent || !channels.length"
        >
          <option value="">
            {{ "campaign.templates.selectChannelOption" | translate }}
          </option>
          @for (channel of channels; track channel._id) {
            <option [value]="channel._id">{{ channel.name }}</option>
          }
        </select>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
  <div class="card">
    <content-loading-list />
  </div>
} @else if (!channels.length) {
  <div class="card">
    <empty-records-component
      [message]="'campaign.templates.noCloudApiChannels' | translate"
      [subMessage]="'campaign.templates.emptySubMessage' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
    />
  </div>
} @else if (!selectedChannel) {
  <div class="card">
    <empty-records-component
      [message]="'campaign.templates.selectChannelMessage' | translate"
      [subMessage]="'campaign.templates.selectChannelSubMessage' | translate"
      [icon]="'mdi mdi-tune-variant'"
    />
  </div>
} @else {
  <settings-template-list-component
    [channel]="selectedChannel"
    [showHeading]="false"
  />
}
